import ReactMarkdown from "react-markdown";

const components = {
  strong: ({ children }) => <span className="num">{children}</span>,
  a: ({ href, children }) => (
    <a href={href} rel="noopener">
      {children}
    </a>
  ),
};

export const Markdown = ({ text }) => <ReactMarkdown components={components}>{text || ""}</ReactMarkdown>;
